module.exports = __webpack_public_path__ + "media/images/flags/bo-b1a8c7bac51d081c70fb19d86950c468.svg";